import React, {useState, createRef, useRef, useEffect, MouseEventHandler} from "react";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import {Button, Modal} from "antd";
import Camera from "../../../assets/icons/camera.png";
import Replace from "../../../assets/icons/replace.png";
import "./image-picker.css";
import Loader from "../../loader/Loader";

interface ImagePickerProps {
    // onImageConfirmed: (image: File | null) => void;
    onImageConfirmed: (base64Image: string | null) => void;
    initialImageUrl?: string;
    previewUrl?: string;
    isLoading?: boolean;
    size?: number;
}

const ImagePicker = ({ onImageConfirmed, initialImageUrl = '', previewUrl= '', isLoading = false, size = 138 }: ImagePickerProps) => {
    const [image, setImage] = useState('');
    const [cropData, setCropData] = useState('');
    const [oldImage, setOldImage] = useState('');
    const [oldCropData, setOldCropData] = useState('');
    const cropperRef = createRef<ReactCropperElement>();
    const inputRef = useRef<HTMLInputElement>(null);

    const onChange = (e: any) => {
        setOldImage(image);
        setOldCropData(cropData);
        try {
            e.preventDefault();
            let files;
            if (e.dataTransfer) {
                files = e.dataTransfer.files;
            } else if (e.target) {
                files = e.target.files;
            }
            const reader = new FileReader();
            reader.onload = () => {
                console.log("onload");
                if(reader.result) {
                    setImage(reader.result as any);
                    setCropData('');
                }
            };
            reader.readAsDataURL(files[0]);
        } catch (error) {
            console.log("error: ", oldImage);
            // setImage(oldImage || '');
            // setCropData(oldCropData || '');
        }
    };

    const getCropData = () => {
        if (typeof cropperRef.current?.cropper !== "undefined") {
            setCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL('image/png'));
        }
    };

    const onConfirm = () => {
        if(!cropData) return;
        onImageConfirmed(cropData);
        setImage('');
    }

    const onImageClick = (event: any) => {
        event.stopPropagation();
        inputRef?.current?.click();
    }

    useEffect(() => {
        const clickableContainer = document.getElementById('image-uploader-container');
        if(clickableContainer) {
            clickableContainer.addEventListener('click', onImageClick);
            return () => {
                clickableContainer.removeEventListener('click', onImageClick);
            }
        }
    }, []);

    return (
        <div className="image-picker-container">
            <div style={{ width: "100%" }}>
                <div className="input-container image" style={{ width: `${size}px`, height: `${size}px` }} onClick={onImageClick}>
                    {isLoading ? <Loader size={48} /> : (previewUrl || cropData || initialImageUrl)
                        ? <div className="preview-image-actions-container">
                            <div className="preview-image-actions">
                                <div className="action replace"><img src={Replace} alt="Replace" /><span>Replace</span></div>
                            </div>
                            <img src={previewUrl || cropData || initialImageUrl} className="image-picker-preview" />
                        </div> : <div><img src={Camera} className="camera-icon" /><span>Upload Image</span></div>}
                    <input ref={inputRef} hidden type="file" onChange={onChange} className="image-picker-file" />
                </div>
                <Modal
                    className="image-picker-modal"
                    open={!!image}
                    zIndex={12050}
                    okButtonProps={{ style: { display: 'none' }}}
                    cancelButtonProps={{ style: { display: 'none' }}}
                >
                    <div className="image-container">
                        {cropData ? <div className="cropped-data-container"><img style={{ width: "300px" }} src={cropData} alt="cropped" /></div> : <Cropper
                            ref={cropperRef}
                            style={{ height: 400, width: "100%" }}
                            zoomTo={0.5}
                            initialAspectRatio={1}
                            aspectRatio={1}
                            src={image}
                            viewMode={1}
                            minCropBoxHeight={192}
                            minCropBoxWidth={192}
                            background={false}
                            responsive={true}
                            autoCropArea={1}
                            checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                            guides={true}
                        />}
                    </div>
                    <div className="actions">
                        <div className="left">
                            <Button type="default" size="large" onClick={() => {
                                setCropData(oldCropData || '');
                                setImage(oldImage || '');
                                if(inputRef?.current?.value) inputRef.current.value = '';
                            }}>Cancel</Button>
                        </div>
                        <div className="right">
                            {cropData ? <>
                                <Button className="back-button" type="text" size="large" onClick={() => setCropData('')}>Back</Button>
                                <Button type="primary" size="large" onClick={onConfirm}>Confirm</Button>
                            </> : <Button type="primary" size="large" onClick={getCropData}>Crop Image</Button>}
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default ImagePicker;
